<template>
  <div class="exchange_card_list">
    <div class="page-title">工具兑换</div>
    <div class="card_list">
      <div class="card_item" v-for="(item, index) in cardLevel" :key="index">
        <div class="card_item_left">
          <div class="card_item_title">{{item.label1}}</div>
          <div class="card_item_info1">{{item.label2}}</br>使用日期起向后一年</div>
        </div>
        <div class="card_item_buy" @click="createCard(item.level)">生成新卡</div>
      </div>
    </div>
    <!-- tab -->
   <div class="tab_list">
     <div class="tab_item" v-for="(tab, tabIndex) in tabs" :key="tabIndex"
       :class="{'tab_item_active': tab.level === curTab}"
       @click="tabClick(tab)"
     >
       {{tab.label}} ({{tab.num}})
     </div>
   </div>
   <!-- table -->
   <pageTable
     :loading="tableLoading"
     :col="col"
     :data="tableData"
     :total="total"
     :pageSize="pageSize"
     :pageIndex="page"
     @pageChange="pageChange"
     @pageSizeChange="pageSizeChange"
     @cell_edit_done="cellEdit"
    ></pageTable>

    <!-- 兑换卡弹框 -->
    <simple-diag
      width="300px"
      :isShow="createDiag"
      title="生成新卡"
      @confirm="confirm"
      @close="close"
      @hide="close"
    >
      <div class="diag_item" style="margin-bottom: 10px;">
        <div class="diag_item_label">类型</div>
        <span>{{curLevel === 'primary' ? '竞品市场调研兑换卡' : '在线会议兑换卡'}}</span>
      </div>
      <div class="diag_item" style="margin-bottom: 10px;">
        <div class="diag_item_label">时间</div>
        <span>1年</span>
      </div>
      <div class="diag_item">
        <div class="diag_item_label">备注</div>
        <count-area :value="extra" @changeVal="changeExtra" :allCount="20" placeholder="公司名称、付款状态等备注信息"></count-area>
      </div>
    </simple-diag>
  </div>
</template>
<script>
import { cardCount, getCardList, createNewCard, changeCardExtro } from '@/api/newagent.js'
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import simpleDiag from '@/components/dialogs/simpleDiag'
import countArea from '@/components/countArea'
import Vue from 'vue'
import copyOpe from './copy'
Vue.component('copyOpe', copyOpe)
export default {
  name: 'exchangetoollist',
  components: { pageTable, simpleDiag, countArea },
  mixins: [pageTableMixin],
  data() {
    return {
      cardLevel: [
        { level: 'primary', label1: '竞品市场调研兑换卡', label2: '仅用于调研报告相关功能' },
        { level: 'inter', label1: '在线会议兑换卡', label2: '仅用于在线会议相关功能' }
      ],
      curLevel: '', // 当前生成卡的等级
      createDiag: false, // 生成卡片弹框
      extra: '', // 生卡备注
      tabs: [
        { label: '全部', level: 'all', num: '0' },
        { label: '竞品市场调研', level: 'primary', num: '0' },
        { label: '在线会议', level: 'inter', num: '0' }
      ],
      curTab: 'all',
      tableData: [],
      col: [
        { field: 'operation', title: '操作', width: 90, titleAlign: 'left', columnAlign: 'left', isResize: true, componentName: 'copyOpe' },
        { field: 'write_time', title: '生成时间', width: 160, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'tool_name_text', title: '工具名称', width: 90, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'tool_time_length', title: '时间', width: 90, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'card_no', title: '卡号', width: 90, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'card_pwd', title: '卡密', width: 120, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'is_use_text', title: '状态', width: 90, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true,
          formatter(rowData, pIndex, index, field) {
            if (rowData[field] === '已使用') {
              return '<span style="color: #2BB968"">已使用</span>'
            } else {
              return rowData[field]
            }
          }
        },
        { field: 'org_name', title: '关联账号', width: 90, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'memo', title: '备注', width: 90, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true, isEdit: true }
      ]
    }
  },
  methods: {
    createCard(level) { // 生成新卡
      const tmp = {
        'primary': '80', 'inter': '90'
      }
      cardCount({
        tool_name: tmp[level]
      }).then(res => {
        if (res.code === 0) {
          this.curLevel = level
          this.createDiag = true
        } else {
          this.$Message.info('同类型未使用卡不能超过10张')
        }
      })
    },
    tabClick(tab) {
      if (tab.level !== this.curTab) {
        this.curTab = tab.level
        this.initPage()
        this.getData()
      }
    },
    initPage() {
      this.tableData = []
      this.total = 0
      this.pageSize = 30
      this.page = 1
    },
    getData() {
      this.tableLoading = true
      const tmp = {
        'all': '80, 90',
        'primary': '80',
        'inter': '90'
      }
      getCardList({
        'tool_name': tmp[this.curTab],
        'current_page': this.page,
        'rp': this.pageSize
      }).then(res => {
        this.tableLoading = false
        if (res.code === 0) {
          this.tableData = res.result.data
          this.total = res.result.total
          this.$set(this.tabs[0], 'num', res.result.all_total.tool_name_all_count_gongju)
          this.$set(this.tabs[1], 'num', res.result.all_total.tool_name_diaoyan_count)
          this.$set(this.tabs[2], 'num', res.result.all_total.tool_name_huiyishi_count)
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    },
    changeExtra(extra) {
      this.extra = extra
    },
    confirm() {
      const tmp = {
        'primary': '80', 'inter': '90'
      }
      createNewCard({
        tool_name: tmp[this.curLevel],
        card_desc: this.extra
      }).then(res => {
        const { code, msg } = res
        if (code === 0) {
          this.$Message.info('生成新卡成功')
          this.close()
          this.getData()
        } else {
          this.$Message.info(msg)
        }
      })
    },
    close() {
      this.createDiag = false
      this.curLevel = ''
      this.extra = ''
    },
    cellEdit(newValue, oldValue, rowIndex) {
      this.$set(this.tableData[rowIndex], 'memo', newValue)
      changeCardExtro({
        detail_id: this.tableData[rowIndex].detail_id,
        memo: newValue
      }).then(res => {
        if (res.code !== 0) {
          this.$Message.info(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.card_list {
  margin-top: 20px;
  display: flex;
  .card_item {
    width: 320px;
    height: 120px;
    margin-right: 20px;
    border: 1px solid #E9EEF6;
    padding: 26px;
    background: #F8F9FA;
    position: relative;
  }
  .card_item_left {
    width: 160px;
    height: 100%;
    border-right: 1px solid  #E9EEF6;
  }
  .card_item_title {
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    color: #5D6F80;
    margin-bottom: 10px;
  }
  .card_item_info1 {
    font-size: 12px;
    line-height: 22px;
    color: #748BA3;
  }
  .card_item_buy {
    position: absolute;
    color: #1881DC;
    width: 48px;
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    cursor: pointer;
    top: 52px;
    left: 216px;
    font-weight: 400;
  }
}
.tab_list {
  margin-top: 30px;
  margin-bottom: 12px;
  padding-left: 10px;
  display: flex;
  height: 28px;
  border-bottom: 1px solid #D9E2EF;
  .tab_item {
    font-size: 13px;
    line-height: 13px;
    margin-right: 66px;
    cursor: pointer;
    position: relative;
    &:hover {
      color: #1881DC;
    }
  }
  .tab_item_active {
    color: #1881DC;
    &:after {
      content: '';
      display: inline-block;
      position: absolute;
      width: 40px;
      height: 2px;
      background: #1881DC;
      top: 26px;
      left: calc(50% - 20px);
    }
  }
}
.diag_item {
  display: flex;
  font-size: 12px;
  .diag_item_label {
    margin-right: 20px;
  }
}
/deep/ .cell-editing {
  .cell-edit-input {
    border: none;
    border-bottom: 1px solid $blue;
  }
}
</style>

